import React from 'react';
import { ShieldCheck, Lock, Zap, CreditCard, Trophy } from 'lucide-react';
export function PricingSection() {
  const checkoutUrl = 'https://kit-tarot-listo.impultienda.ar/checkout/kit-tarot-listo';
  const items = [{
    name: 'Guía Principal Tarot Listo™',
    value: '$29.990'
  }, {
    name: 'Bono 1: Tiradas Poderosas™',
    value: '$19.990'
  }, {
    name: 'Bono 2: Diccionario Intuitivo™',
    value: '$19.990'
  }, {
    name: 'Bono 3: Rituales con Tarot™',
    value: '$19.990'
  }, {
    name: 'Bono 4: Preguntas Mágicas™',
    value: '$19.990'
  }, {
    name: 'Bono 5: Lecturas Reales™',
    value: '$19.990'
  }, {
    name: 'Bono 6: Sistema de Seguimiento™',
    value: '$15.990'
  }];
  return <section id="oferta" className="px-5 relative overflow-hidden" data-id="element-190">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-191">
        <div className="text-center mb-4 md:mb-8" data-id="element-192">
          <h2 className="text-2xl md:text-5xl font-bold text-brand-petroleum mb-2 tracking-tight flex items-center justify-center gap-2" data-id="element-193">
            <span className="text-xl md:text-4xl" data-id="element-194">🏆</span> Oferta Especial de
            Lanzamiento
          </h2>
        </div>

        <div className="relative pt-2" data-id="element-195">
          {/* Content Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 z-20" data-id="element-196">
            <div className="bg-brand-petroleum text-white text-[9px] md:text-[10px] font-bold px-5 py-1.5 rounded-full uppercase tracking-[0.2em] shadow-lg border border-white/10" data-id="element-197">
              Contenido del kit:
            </div>
          </div>

          {/* Main Card */}
          <div className="bg-white rounded-[32px] md:rounded-[40px] border-2 border-brand-petroleum p-5 md:p-8 shadow-2xl relative overflow-hidden" data-id="element-198">
            {/* Itemized List */}
            <div className="space-y-1.5 md:space-y-3 mb-4 md:mb-8 pt-1 md:pt-2" data-id="element-199">
              {items.map((item, idx) => <div key={idx} className="flex justify-between items-center border-b border-brand-petroleum/5 pb-1 md:pb-2" data-id="element-200">
                  <span className="text-[13px] md:text-base font-medium text-brand-petroleum/80" data-id="element-201">
                    {item.name}
                  </span>
                  <span className="text-[13px] md:text-base font-bold text-brand-terracotta/40 line-through" data-id="element-202">
                    {item.value}
                  </span>
                </div>)}
            </div>

            {/* Total Value Row */}
            <div className="flex justify-between items-center mb-4 md:mb-8" data-id="element-203">
              <span className="text-base md:text-xl font-black text-brand-petroleum uppercase tracking-tight" data-id="element-204">
                VALOR TOTAL:
              </span>
              <span className="text-base md:text-xl font-black text-brand-terracotta line-through" data-id="element-205">
                $145.980
              </span>
            </div>

            {/* Main Price Display */}
            <div className="text-center mb-4 md:mb-8" data-id="element-206">
              <div className="flex items-center justify-center gap-3 md:gap-4 mb-1" data-id="element-207">
                <span className="text-2xl md:text-5xl" data-id="element-208">🏆</span>
                <div className="flex flex-col items-start" data-id="element-209">
                  <span className="text-3xl md:text-6xl font-black text-brand-petroleum tracking-tighter leading-none" data-id="element-210">
                    $19.990 ARS
                  </span>
                  <span className="text-xs md:text-lg font-bold text-brand-terracotta/40 line-through ml-0.5" data-id="element-211">
                    $145.980 ARS
                  </span>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="mb-4 md:mb-6" data-id="element-212">
              <a href={checkoutUrl} className="block w-full bg-brand-petroleum text-white py-4 md:py-6 px-4 md:px-8 rounded-[20px] md:rounded-[24px] transition-all hover:scale-[1.02] hover:bg-brand-petroleum/90 text-center no-underline text-base md:text-xl font-black uppercase tracking-wider shadow-xl" data-id="element-213">
                ✨ QUIERO EL KIT TAROT LISTO
              </a>
            </div>

            {/* Footer Info */}
            <div className="text-center space-y-1 md:space-y-2" data-id="element-214">
              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-4 gap-y-0.5 text-[9px] md:text-xs font-bold text-brand-medium-grey uppercase tracking-widest" data-id="element-215">
                <span data-id="element-216">Descarga inmediata</span>
                <span className="opacity-30" data-id="element-217">•</span>
                <span data-id="element-218">Pago único</span>
              </div>
              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-4 gap-y-0.5 text-[9px] md:text-xs font-bold text-brand-medium-grey uppercase tracking-widest" data-id="element-219">
                <span data-id="element-220">Acceso de por vida</span>
                <span className="opacity-30" data-id="element-221">•</span>
                <span data-id="element-222">7 días de garantía</span>
              </div>
            </div>
          </div>
        </div>

        {/* Security Badges */}
        <div className="mt-6 md:mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-8 opacity-60" data-id="element-223">
          <div className="flex items-center gap-1.5 text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-brand-petroleum" data-id="element-224">
            <Lock size={12} data-id="element-225" />
            <span data-id="element-226">Pago Seguro</span>
          </div>
          <div className="flex items-center gap-1.5 text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-brand-petroleum" data-id="element-227">
            <ShieldCheck size={12} data-id="element-228" />
            <span data-id="element-229">Garantía Total</span>
          </div>
          <div className="flex items-center gap-1.5 text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-brand-petroleum" data-id="element-230">
            <CreditCard size={12} data-id="element-231" />
            <span data-id="element-232">MercadoPago</span>
          </div>
        </div>
      </div>
    </section>;
}